import apiClient from './apiClient';

export const fetchContent = () =>
  apiClient.get('/rubrica.php').then(r => r.data);

export const saveContent = (content) =>
  apiClient.post('/rubrica.php?action=save', { content }).then(r => r.data);
